// src/components/Login/loginBodecom.jsx

import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import { Input, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'antd/dist/reset.css';
import './LoginBodecom.css';
import logoBodecom from '../../assets/bodecom.png';
import btn_sabor from '../../assets/logo_427.png';
import logosConveio from '../../assets/Logo_Prosperidad_Social.png';
import './SaborButton.css';

import { useDispatch, useSelector } from 'react-redux';
import { login } from '../../store/auth/authSlice';

const LoginBodecom = () => {
    // Estados de formulario
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    // Estado local para indicar que se pulsó "Iniciar sesión"
    const [attemptedLogin, setAttemptedLogin] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { loading, error, user } = useSelector((state) => state.auth);

    // Efecto que maneja la navegación tras login o muestra error
    useEffect(() => {

        if (user && user.username) {
            if (user.applications && user.applications.length === 0) {
                console.warn('⚠️ No tiene aplicaciones asignadas.');
                message.error('El usuari@ no tiene aplicaciones asignadas.', 5);
            } else {
                message.success('Bienvenid@!');
                navigate('/inicio');
            }
        } else if (attemptedLogin && error) {
            console.error('❌ Error en autenticación:', error);
            message.error('Error en la autenticación del usuario.', 5);
        }
        console.groupEnd();
    }, [user, error, attemptedLogin, navigate]);

    // Manejador del submit del formulario
    const handleSubmit = (e) => {
        e.preventDefault();
        setAttemptedLogin(true);
        dispatch(login({ username, password }));
    };

    return (
        <div className="login-background">
            {/* Header de logos */}
            <header className="header-logos">
                <Container
                    fluid
                    className="d-flex flex-column flex-md-row align-items-center justify-content-between contenedorLogos"
                >
                    <img
                        src={logosConveio}
                        alt="Logos Convenio"
                        className="logos-convenio-img mb-2 mb-md-0"
                        height={60}
                    />
                    <img
                        src={btn_sabor}
                        alt="Sabor a Paz"
                        className="sabor-btn"
                        width="10%"
                        height="10%"
                        style={{ marginRight: '9%' }}
                        onClick={() => window.open('https://www.4-72.com.co/', '_blank')}
                    />
                </Container>
            </header>

            {/* Contenido principal (login) */}
            <Container className="login-container pt-header d-flex align-items-center">
                <Row className="w-100 justify-content-end">
                    {/* Col derecha: formulario */}
                    <Col md={4} sm={12} className="login-form-wrapper">
                        <div className="login-form-box">
                            <div className="contenLogo">
                                <img
                                    src={logoBodecom}
                                    alt="Bodecom Logo"
                                    className="logo pb-3"
                                    width={250}
                                />
                            </div>
                            <Form onSubmit={handleSubmit}>
                                <Form.Group controlId="formBasicUsername">
                                    <Form.Label className="titleLabel">Usuario</Form.Label>
                                    <Input
                                        type="text"
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                        placeholder="Digite usuario"
                                        className="mb-3"
                                        required
                                    />
                                </Form.Group>
                                <Form.Group controlId="formBasicPassword">
                                    <Form.Label className="titleLabel">Clave</Form.Label>
                                    <Input.Password
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder="Digite contraseña"
                                        className="mb-3"
                                        required
                                    />
                                </Form.Group>
                                <Button
                                    variant="primary"
                                    type="submit"
                                    className="w-100"
                                    disabled={loading}
                                >
                                    {loading ? 'Iniciando sesión...' : 'Iniciar sesión'}
                                </Button>
                            </Form>
                            <h2 className="text-center mt-2">Bienvenid@</h2>

                            <hr />
                            <h6 className="text-center">
                                <a
                                    href="https://soporte.bodecom.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Mesa de Ayuda - Comunix SAS
                                </a>
                            </h6>
                            <h6 className="text-center">soporte@comunix.co</h6>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default LoginBodecom;
